module.exports = __webpack_public_path__ + "img/view_device_c1_two.b6d58587.jpg";